import React, { useEffect, useRef } from "react";
import { Button, Modal } from "antd";
import { fabric } from "fabric";
import './styles.css';

const TemplatePreview = ({ visible, onClose, template,applyTemplate  }) => {
    const previewCanvasRef = useRef(null);
    const containerWidth = 600;
    const containerHeight = 400;

    useEffect(() => {
        if (!visible || !template?.data?.objects) return;

        setTimeout(() => {
            const canvasElement = previewCanvasRef.current;
            if (!canvasElement) return;

            // ✅ Set a fixed canvas size inside modal
            canvasElement.width = containerWidth;
            canvasElement.height = containerHeight;

            const canvas = new fabric.Canvas(canvasElement, {
                backgroundColor: "white",
            });

            fabric.util.enlivenObjects(template.data.objects, (objects) => {
                const group = new fabric.Group(objects, { selectable: false });

                // ✅ Scale template to fit inside modal properly
                const scaleX = (containerWidth - 40) / group.width; // 40px padding
                const scaleY = (containerHeight - 60) / group.height; // 60px padding for header
                const scale = Math.min(scaleX, scaleY) * 0.85; // Slightly smaller for padding

                group.scale(scale);

                // ✅ Adjust top and left to keep canvas inside modal
                group.set({
                    left: (containerWidth - group.width * scale) / 2,
                    top: Math.max((containerHeight - group.height * scale) / 2, 30), // Prevents overlap
                });

                // ✅ Clear previous canvas and add new objects
                canvas.clear();
                canvas.add(group);
                canvas.renderAll();
            });

            return () => canvas.dispose();
        }, 100); // Small delay ensures modal is fully open
    }, [visible, template]);

    const handleApplyTemplate = () =>{
        applyTemplate(template);
        onClose();
    }

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>Close</Button>,
                <Button key="apply" type="primary" onClick={handleApplyTemplate}>Apply Template</Button>
            ]}
            title="Template Preview"
            width={containerWidth + 50}
            className="template-preview-modal"
            bodyStyle={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: containerHeight + 40,
                overflow: "hidden",
                paddingTop: "20px",
                paddingBottom: "20px",
            }}
        >
            <div className="template-preview-container">
                <canvas className="preview-canvas" ref={previewCanvasRef} style={{ border: "1px solid #ddd" }} />
            </div>
        </Modal>
    );
};

export default TemplatePreview;
